<template>
  <div class="col">
    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit.prevent="startSearch"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Filters</h4>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="Login"
                  >
                    Login
                  </label>
                  <v-select
                    multiple
                    :taggable="true"
                    :searchable="true"
                    v-model="params.Logins"
                    placeholder="Select logins"
                    class="custom-select form-control noclose"
                    :select-on-key-codes="[188, 13]"
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="loginForQueryRequired && (params.Logins == null || params.Logins.length == 0)"
                        v-bind="attributes"
                        v-on="events"
                      >
                    </template>
                    <template slot="no-options">
                          &nbsp;
                    </template>
                  </v-select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="From"
                  >
                    From
                  </label>
                  <input
                    type="date"
                    min="2016-04-01"
                    v-model="params.FromDate"
                    class="form-control m-input  m-input--solid"
                    id="From"
                    name="From"
                    required
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="To"
                  >
                    To
                  </label>
                  <input
                    type="date"
                    min="2016-04-01"
                    :max="maxDayToday"
                    v-model="params.ToDate"
                    class="form-control m-input  m-input--solid"
                    id="To"
                    name="To"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="agentref"
                  >
                    Reference
                  </label>
                  <input
                    id="agentref"
                    v-model="params.AgentRef"
                    class="form-control m-input  m-input--solid"
                    placeholder="E.g. AX8912"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="Tickboxes"
                  >
                    Tickboxes
                  </label>
                  <v-select
                    multiple
                    :taggable="true"
                    :searchable="true"
                    v-model="params.Tickboxes"
                    :options="['contact-form', 'contact-me', 'schedule-visit', 'send-whatsapp', 'exact-location', 'more-photos']"
                    placeholder="Options during enquiry"
                    class="custom-select form-control noclose"
                    :select-on-key-codes="[188, 13]"
                  />
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="propertyId"
                  >
                    thinkSPAIN ID
                  </label>
                  <input
                    id="propertyId"
                    v-model.number="params.PropertyId"
                    class="form-control m-input  m-input--solid"
                    placeholder="E.g. 123456"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="device"
                  >
                    Via
                  </label>
                  <select
                    v-model="params.Type"
                    :value="params.Type"
                    class="form-control"
                  >
                    <option value="all">
                      All Enquiries
                    </option>
                    <option value="web">
                      Contact form enquiries
                    </option>
                    <option value="phone">
                      Telephone calls
                    </option>
                    <option value="direct">
                      Direct enquiries
                    </option>
                    <option value="similar">
                      Similar enquiries
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="country"
                  >
                    Visitor Country
                  </label>
                  <select
                    v-model.number="params.OfferType"
                    :value="params.OfferType"
                    class="form-control"
                  >
                    <option value="null">
                      Select
                    </option>
                    <option value="3">
                      For sale
                    </option>
                    <option value="4">
                      For rent
                    </option>
                    <option value="2">
                      For holidays
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="agentref"
                  >
                    Name
                  </label>
                  <input
                    id="agentref"
                    v-model="params.Name"
                    class="form-control m-input  m-input--solid"
                    placeholder="Eg: Thomas"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="agentref"
                  >
                    Email
                  </label>
                  <input
                    id="agentref"
                    v-model="params.Email"
                    class="form-control m-input  m-input--solid"
                    placeholder="E.g. leads@mybusiness.com"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="phone"
                  >
                    Telephone:
                  </label>
                  <input
                    id="phone"
                    v-model="params.Phone"
                    class="form-control m-input  m-input--solid"
                    placeholder="E.g. 666 555 444"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="phone"
                  >
                    Message
                  </label>
                  <input
                    id="phone"
                    v-model="params.Comment"
                    class="form-control m-input  m-input--solid"
                    placeholder="Message"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="spam"
                  >
                    Spam
                  </label>
                  <select
                    class="form-control"
                    v-model="params.Spam"
                    :disabled="!canViewSpamEnquiries"
                  >
                    <option :value="null">
                      Select
                    </option>
                    <option :value="true">
                      Spam
                    </option>
                    <option :value="false">
                      Non Spam
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <hr>
    <div
      class="row mt-3"
      v-if="searchParams"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-12 mb-3">
                <div class="pull-left">
                  Records:
                  <span v-if="enquiries.length == 0">No records found</span>
                  <span v-else-if="enquiries.length > 0 && pagination.total <= recordTo">{{ recordFrom }} to {{ recordTo }}</span>
                  <span v-else>{{ recordFrom }} to {{ recordTo }} from {{ pagination.total }}</span>
                </div>
                <a
                  v-if="canExport"
                  class="pull-right"
                  style="float:right;cursor:pointer"
                  @click.prevent.stop="exportData"
                >
                  <span>
                    <i class="la la-download" />
                    <span>Export to excel</span>
                  </span>
                </a>
              </div>
              <table
                id="tablePropertiesEnquiries"
                class="table table-striped with-header-border not-responsive not-collapse"
              >
                <thead>
                  <tr class="">
                    <th
                      style="width:auto;"
                      class="align-middle text-center showMobile"
                      colspan="2"
                    >
                      <div
                        style="float: left;"
                        v-if="enquiries.length > 0"
                      >
                        <input
                          type="checkbox"
                          class="form-control"
                          :checked="allSelected"
                          @change="selectAll"
                          id="checkAll"
                        >
                      </div>
                      <div
                        class="btn-group"
                        id="actions"
                      >
                        <button
                          type="button"
                          class="btn btn-primary dropdown-toggle"
                          :disabled="this.selectedEnquiries.length == 0"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          @click="openDropdown"
                        >
                          Action
                        </button>
                        <div
                          class="dropdown-menu"
                          style="min-width: 300px;"
                          @click="dropdownClick"
                        >
                          <form
                            class="px-4 py-3"
                            @submit.prevent="resendEmail"
                          >
                            <h5>Resend</h5>
                            <div class="form-group">
                              <label for="email">Email address</label>
                              <input
                                required
                                type="email"
                                name="email"
                                class="form-control"
                                placeholder="forward@email.to"
                                v-model="resendDestination"
                              >
                            </div>
                            <div class="form-group">
                              <label for="language">Language</label>
                              <select
                                class="form-control"
                                v-model="resendLanguage"
                              >
                                <option value="en">
                                  English
                                </option>
                                <option value="es">
                                  Spanish
                                </option>
                              </select>
                            </div>
                            <button
                              type="submit"
                              class="btn btn-primary"
                            >
                              Resend Selected Emails
                            </button>
                          </form>
                          <div
                            class="dropdown-divider"
                            v-if="canMarkEnquiriesAsSpam"
                          />
                          <form
                            class="px-4 py-3"
                            @submit.prevent="reportSpam"
                            v-if="canMarkEnquiriesAsSpam"
                          >
                            <h5>Report spam</h5>
                            <div class="form-group">
                              <label for="reason">Reason:</label>
                              <textarea
                                required
                                name="reason"
                                class="form-control"
                                placeholder="Reason ... "
                                v-model="spamReason"
                              />
                            </div>
                            <button
                              type="submit"
                              class="btn btn-primary"
                            >
                              Report as Spam
                            </button>
                          </form>
                          <div
                            class="dropdown-divider"
                            v-if="canAddSpamFlag"
                          />
                          <form
                            class="px-4 py-3"
                            @submit.prevent="addSpamFlag"
                            v-if="canAddSpamFlag"
                          >
                            <h5>Add spam flag to selected enquiries, e.g. To remove test enquiries</h5>
                            <span
                              class="text-warning"
                              v-if="!selectedEnquiriesAreWithLast30Days"
                            >
                              Note: Spam flag can only be added for enquiries made in the last 30 days
                              <br>
                            </span>
                            <button
                              type="submit"
                              class="btn btn-primary"
                              :disabled="selectedEnquiriesAreSpam || !selectedEnquiriesAreWithLast30Days"
                            >
                              Add spam flag
                            </button>
                          </form>
                          <div
                            class="dropdown-divider"
                            v-if="canRemoveSpamFlag"
                          />
                          <form
                            class="px-4 py-3"
                            @submit.prevent="removeSpamFlag"
                            v-if="canRemoveSpamFlag"
                          >
                            <h5>Remove spam flag from selected enquiries</h5>
                            <span
                              class="text-warning"
                              v-if="!selectedEnquiriesAreWithLast30Days"
                            >
                              Note: Spam flag can only be removed from enquiries made in the last 30 days
                            </span>
                            <button
                              type="submit"
                              class="btn btn-primary"
                              :disabled="!selectedEnquiriesAreSpam || !selectedEnquiriesAreWithLast30Days"
                            >
                              Remove spam flag
                            </button>
                          </form>
                        </div>
                      </div>
                    </th>
                    <th
                      style="width:15%;"
                      class="text-left"
                    >
                      Date <small> / </small> Sent To <small> / </small> Id <small> / </small> Ref <small> / </small> Price
                    </th>
                    <th
                      style="width:auto;"
                      class="text-left"
                    >
                      Tickboxes
                    </th>
                    <th
                      style="width:15%;"
                      class="text-left"
                    >
                      From
                    </th>
                    <th
                      style="width:auto;"
                      class="text-left"
                    >
                      Language <small>
                        / </small>Location
                    </th>
                    <th
                      style="width:35%;"
                      class="text-left"
                    >
                      Message
                    </th>
                    <th
                      v-if="enquiries.some(x => !!x.Data.Match)"
                    >
                      Event Match
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr
                      v-for="(enquiry, index) in enquiries"
                      :key="index"
                      :style="getRowStyle(enquiry)"
                    >
                      <template>
                        <td
                          class="align-middle"
                          data-thead-name=""
                        >
                          <div class="m-checkbox-inline-block">
                            <label class="m-checkbox m-checkbox--solid m-checkbox--brand">
                              <input
                                type="checkbox"
                                class=""
                                v-model="selectedEnquiries"
                                :value="enquiry"
                              >
                              <span />
                            </label>
                          </div>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name=""
                        >
                          <template v-if="enquiry.Property">
                            <a
                              :href="enquiry.Data.PropertyURL + '?preview=1'"
                              target="_blank"
                            >
                              <template v-if="getFirstPhoto(enquiry.Property)">
                                <img
                                  :src="photoUrl(getFirstPhoto(enquiry.Property))"
                                  width="120px"
                                >
                              </template>
                              <template v-else>
                                <span class="img-cont">
                                  <i class="la la-camera m--icon-font-size-lg3 d-block" />
                                  <span class="d-block small">No Images</span>
                                </span>
                              </template>

                            </a>
                          </template>
                          <template v-else>
                            <i class="la la-phone la-phone-valign" />
                            <template v-if="enquiry.Data.Destination && enquiry.Data.Destination.toLowerCase() != 'not applicable'">
                              +{{ enquiry.Data.Destination }}
                            </template>
                            <template v-else-if="enquiry.Data.Reason && enquiry.Data.Reason.toLowerCase() == 'time based'">
                              HANGUP
                            </template>
                            <template v-else>
                              Out of Hours
                            </template>
                          </template>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name="Date / Sent To / Id / Ref / Price"
                        >
                          <template v-if="enquiry.Property">
                            {{ formatDate(enquiry.Data.SendDate) }}
                            <br>
                            <template v-if="enquiry.Data.ResendDate">
                              Re-sent: {{ formatDate(enquiry.Data.ResendDate) }}
                              <br>
                            </template>
                            {{ enquiry.Data.AgentEmail }}
                            <br>
                            <a
                              :href="enquiry.Data.PropertyURL + '?preview=1'"
                              target="_blank"
                            >
                              {{ enquiry.Data.PropertyId }}
                            </a>
                            <br><strong>{{ enquiry.Property.AgentRef }}</strong>
                            <br>
                            <span v-html="showPrice(enquiry.Property)" />
                          </template>
                          <template v-else>
                            {{ formatDate(enquiry.Data.Start) }}
                          </template>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name=""
                        >
                          <template v-if="enquiry.Data.Tickboxes && enquiry.Data.Tickboxes.length > 0">
                            <div
                              v-for="(tickbox, tidx) in enquiry.Data.Tickboxes"
                              :key="tidx"
                            >
                              {{ tickbox }}
                            </div>
                          </template>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name="From"
                        >
                          <template v-if="enquiry.Data.Email">
                            {{ enquiry.Data.Name }} <br>{{ enquiry.Data.Email }} <br>{{ enquiry.Data.Phone }}
                          </template>
                          <template v-else>
                            +{{ enquiry.Data.Origin }}
                          </template>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name="Language / Location"
                        >
                          <template v-if="enquiry.Data.Language">
                            <img
                              alt=""
                              width="25px"
                              class="m--hidden-tablet-and-mobile"
                              :src="'https://d1pk7baiyvt4yj.cloudfront.net/assets/v-bbc69dd/img/flags/'+ getFlag(enquiry.Data.Language.toLowerCase())+'.png'"
                            >

                            {{ enquiry.Data.Language.toUpperCase() }}
                          </template>

                          <template v-if="enquiry.Data.Country">
                            <br>
                            <i class="la la-map-marker m--hidden-tablet-and-mobile" />
                            {{ enquiry.Data.Country.toUpperCase() }}
                          </template>

                          <template v-if="enquiry.Data.Start">
                            <i class="la la-map-marker" /> {{ (enquiry.Data.OriginLocation || "").replace(/,(?! )/, ', ') }}
                          </template>
                        </td>
                        <td
                          class="align-middle"
                          data-thead-name="Message"
                        >
                          <template v-if="enquiry.Data.Result">
                            {{ enquiry.Data.Result }}
                            <span v-if="enquiry.Data.TalkTimeSec > 0">(Call time: {{ formatDuration(enquiry.Data.TalkTimeSec) }})</span>
                          </template>
                          <template v-if="enquiry.Data.Comment">
                            <span
                              class="comment"
                            >
                              {{ enquiry.Data.Comment }}
                            </span>
                          </template>
                        </td>
                        <th
                          v-if="enquiries.some(x => !!x.Data.Match)"
                          class="text-center"
                        >
                          <template v-if="enquiry.Data.Match">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-primary"
                              @click="selectedCall = enquiry"
                            >
                              View
                            </button>
                          </template>
                          <template v-else>
                            <span class="font-weight-normal">N/A</span>
                          </template>
                        </th>
                      </template>
                    </tr>
                  </template>
                  <template v-if="enquiries.length === 0">
                    <tr>
                      <td
                        colspan="11"
                        class="text-center m--regular-font-size-lg3 py-5"
                      >
                        <template v-if="!loading">
                          No records found
                        </template>
                        <template v-else>
                          Sending request, please wait
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <!--Begin::Pagination-->
              <Pagination
                :total-pages="this.pagination.totalPages"
                :total="this.pagination.total"
                :loading="false"
                :current-page="this.pagination.currentPage"
                @pagechanged="onPageChange"
              />
              <div class="m-separator m-separator--dashed mt-2" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="selectedCall != null"
      class="modal fade px-0 show d-block"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
        style="max-width: 900px;"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Call Info
            </h5>
            <button
              type="button"
              class="close"
              @click="selectedCall = null"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="modal-body container-fluid"
          >
            <ul class="list-group">
              <li class="list-group-item">
                <strong>ID:</strong> {{ selectedCall.Data.Id }}
              </li>
              <li class="list-group-item">
                <strong>From:</strong> +{{ selectedCall.Data.Origin }} ({{ selectedCall.Data.OriginLocation }})
              </li>
              <li class="list-group-item">
                <strong>Date:</strong> {{ new Date(selectedCall.Data.Start).toUTCString() }}
              </li>
              <li class="list-group-item">
                <strong>Property IDs:</strong> {{ selectedCall.Data.Match.propertyIDs.join( ',' ) }}
              </li>
              <li class="list-group-item">
                <strong>Match:</strong> {{ selectedCall.Data.Match.type }} / {{ selectedCall.Data.Match.status }}
              </li>
              <li class="list-group-item">
                <strong>Calls:</strong>
                <ol class="mt-2">
                  <li
                    v-for="(l, i) in selectedCall.Data.Match.callLogs"
                    :key="l.callId"
                    :class="`${i !== 0 ? 'mt-2' : ''}`"
                  >
                    <p class="mb-0">
                      <strong>ID:</strong> {{ l.callId }}
                    </p>
                    <p class="mb-0">
                      <strong>From:</strong> +{{ l.callOrigin }} ({{ l.callerLocation }})
                    </p>
                    <p class="mb-0">
                      <strong>Date:</strong> {{ new Date(l.callStart).toUTCString() }}
                    </p>
                  </li>
                </ol>
              </li>
              <li class="list-group-item">
                <strong>Events:</strong>
                <ol class="mt-2">
                  <li
                    v-for="(e, i) in selectedCall.Data.Match.events"
                    :key="i"
                    :class="`${i !== 0 ? 'mt-2' : ''}`"
                  >
                    <p class="mb-0">
                      <strong>Date:</strong> {{ new Date(e.eventTime).toUTCString() }}
                    </p>
                    <p
                      v-if="e.event.userID"
                      class="mb-0"
                    >
                      <strong>User ID:</strong> {{ e.event.userID }}
                    </p>
                    <p class="mb-0">
                      <strong>Language:</strong> {{ e.language }}
                    </p>
                    <p class="mb-0">
                      <strong>Country:</strong> {{ e.viewerCountry }}
                    </p>
                    <p class="mb-0">
                      <strong>IP:</strong> {{ e.ip }}
                    </p>
                    <p
                      v-if="e.event.origins"
                      class="mb-0"
                    >
                      <strong>Phones:</strong> {{ e.event.origins.join( ', ') }}
                    </p>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { hasPolicyWithAnyAction, requiresLoginForAction } from '../../../../auth/index';
import store from '../../../../store';

import Pagination from './pagination.vue';

import notify from '../../../../notifications';
import http from '../../../../http';
import dayjs from 'dayjs';

export default {
    data() {
        return {
            params: {
                Spam: false,
                Skip: 0,
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                AgentRef: '',
                PropertyId: '',
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Comment: '',
                OfferType: null,
                Logins: [],
                Tickboxes: []
            },
            searchParams: null,
            resendDestination: '',
            resendLanguage: 'en',
            spamReason: '',
            selectedEnquiries: [],
            selectedCall: null,
            pagination: {
                total: 0,
                totalPages: 0,
                currentPage: 1
            },
            enquiries: [],
            totalEnquiries: 0,
            loading: false,
            cdn_url: process.env.CDN_URL,
            total: 0,
            resultsPerPage: 20
        };
    },
    async created() {
        this.updateParamsFromRoute();

        if ( this.loginForQueryRequired && this.params.Logins.length == 0 ) {
            return;
        }
        this.doSearch();
    },
    watch: {
        '$route.query': {
            handler: function( ) {
                this.updateParamsFromRoute();
                this.doSearch();
            },
            immediate: false
        }
    },
    computed: {
        recordFrom() {
            return ( this.resultsPerPage * ( this.pagination.currentPage - 1 ) ) + 1;
        },
        recordTo() {
            return Math.min( this.recordFrom + this.resultsPerPage - 1, this.pagination.total );
        },
        maxDayToday() {
            return dayjs().tz().format( 'YYYY-MM-DD' );
        },
        allSelected() {
            return this.selectedEnquiries.length == this.enquiries.length;
        },
        loginForQueryRequired() {
            return requiresLoginForAction( store.state.user, 'enquiry:property:read:non-spam', 'enquiry:property:read:*', 'enquiry:property:*', 'enquiry:*' );
        },
        canViewSpamEnquiries() {
            return hasPolicyWithAnyAction( store.state.user, 'enquiry:*', 'enquiry:property:*', 'enquiry:property:read:*' );
        },
        canRemoveSpamFlag() {
            return hasPolicyWithAnyAction( store.state.user, 'enquiry:*', 'enquiry:property:*', 'enquiry:property:removespamflag' );
        },
        canAddSpamFlag() {
            return hasPolicyWithAnyAction( store.state.user, 'enquiry:*', 'enquiry:property:*', 'enquiry:property:addspamflag' );
        },
        canMarkEnquiriesAsSpam() {
            return hasPolicyWithAnyAction( store.state.user, 'enquiry:*', 'enquiry:property:*', 'enquiry:property:markasspam' );
        },
        selectedEnquiriesAreSpam() {
            return this.selectedEnquiries.length > 0 && this.selectedEnquiries.length === this.selectedEnquiries.filter( e => e.Data.IsSpam ).length;
        },
        selectedEnquiriesAreWithLast30Days() {
            return this.selectedEnquiries.length == 0 || this.selectedEnquiries.length === this.selectedEnquiries.filter( e => dayjs().diff( dayjs( e.Data.SendDate ), 'day' ) <= 30 ).length;
        }
    },
    methods: {
        openDropdown(  ) {
            // update resend email if has unique email
            let emails = this.selectedEnquiries.map( e => {
                if ( e.Type == 'web-enquiry' ) {
                    return e.Data.AgentEmail;
                } else {
                    return e.Data.OutletEmail;
                }
            } ).filter( ( value, index, self ) => {
                return self.indexOf( value ) === index;
            } );

            if ( emails.length == 1 ) {
                this.resendDestination = emails[ 0 ];
            } else {
                this.resendDestination = '';
            }

            let language = this.selectedEnquiries.filter( e => e.Type == 'web-enquiry' ).map( e => {
                return e.Data.Language;
            } ).filter( ( value, index, self ) => {
                return self.indexOf( value ) === index;
            } );

            if ( language.length == 1 && [ 'en', 'es' ].includes( language[ 0 ] ) ) {
                this.resendLanguage = language[ 0 ];
            } else {
                this.resendLanguage = 'en';
            }
        },
        dropdownClick( event ) {
            // Prevent the dropdown from closing when the form is clicked
            if ( event.target.tagName === 'BUTTON' || event.target.tagName === 'BUTTON' || event.target.tagName === 'FORM' || event.target.tagName === 'SELECT' ) {
                event.stopPropagation();
            }
        },
        canExport() {
            return hasPolicyWithAnyAction( store.state.user, [ 'enquiry:*', 'enquiry:property:*', 'enquiry:property:export' ] );
        },
        getDefaultParams() {
            return {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().format( 'YYYY-MM-DD' ),
                Spam: this.canViewSpamEnquiries ? null : false,
                Skip: 0,
                AgentRef: '',
                PropertyId: '',
                Name: '',
                Email: '',
                Phone: '',
                Type: 'all',
                Comment: '',
                OfferType: null,
                Logins: [],
                Tickboxes: []
            };
        },
        updateParamsFromRoute() {
            let defaultParams = this.getDefaultParams();
            this.params.FromDate = this.$route.query.fromdate || defaultParams.FromDate;
            this.params.ToDate = this.$route.query.todate || defaultParams.ToDate;
            this.params.Spam = this.$route.query.spam || defaultParams.Spam;
            this.params.Skip = this.$route.query.skip || defaultParams.Skip;
            this.params.AgentRef = this.$route.query.agentref || defaultParams.AgentRef;
            this.params.PropertyId = this.$route.query.propertyid || defaultParams.PropertyId;
            this.params.Name = this.$route.query.name || defaultParams.Name;
            this.params.Email = this.$route.query.email || defaultParams.Email;
            this.params.Phone = this.$route.query.phone || defaultParams.Phone;
            this.params.Type = this.$route.query.type || defaultParams.Type;
            this.params.Comment = this.$route.query.comment || defaultParams.Comment;
            this.params.OfferType = this.$route.query.offertype || defaultParams.OfferType;

            if ( this.$route.query.login )
                this.params.Logins = Array.isArray( this.$route.query.login ) ? this.$route.query.login : [ this.$route.query.login ];

            if ( this.$route.query.tickboxes ) {
                this.params.Tickboxes = Array.isArray( this.$route.query.tickboxes ) ? this.$route.query.tickboxes : [ this.$route.query.tickboxes ];
            }
        },
        updateRouteFromParams() {
            let defaultParams = this.getDefaultParams();

            let newRouteParams = {
                fromdate: this.params.FromDate,
                todate: this.params.ToDate
            };

            if ( this.params.Spam != defaultParams.Spam ) {
                newRouteParams.spam = this.params.Spam;
            }

            if ( this.params.Skip != defaultParams.Skip ) {
                newRouteParams.skip = this.params.Skip;
            }

            if ( this.params.AgentRef != defaultParams.AgentRef ) {
                newRouteParams.agentref = this.params.AgentRef;
            }

            if ( this.params.PropertyId != defaultParams.PropertyId ) {
                newRouteParams.propertyid = this.params.PropertyId;
            }

            if ( this.params.Name != defaultParams.Name ) {
                newRouteParams.name = this.params.Name;
            }

            if ( this.params.Email != defaultParams.Email ) {
                newRouteParams.email = this.params.Email;
            }

            if ( this.params.Phone != defaultParams.Phone ) {
                newRouteParams.phone = this.params.Phone;
            }

            if ( this.params.Type != defaultParams.Type ) {
                newRouteParams.type = this.params.Type;
            }

            if ( this.params.Comment != defaultParams.Comment ) {
                newRouteParams.comment = this.params.Comment;
            }

            if ( this.params.OfferType != defaultParams.OfferType ) {
                newRouteParams.offertype = this.params.OfferType;
            }

            if ( this.params.Logins != defaultParams.Logins ) {
                newRouteParams.login = this.params.Logins;
            }

            if ( this.params.Tickboxes != defaultParams.Tickboxes ) {
                newRouteParams.tickboxes = this.params.Tickboxes;
            }

            if ( JSON.stringify( this.$route.query ) !== JSON.stringify( newRouteParams ) ) {
                this.$router.push( { query: newRouteParams } );
            }
        },
        selectAll() {
            if ( this.allSelected ) {
                this.selectedEnquiries = [];
                return;
            }
            this.selectedEnquiries = this.enquiries;
        },
        clearForm() {
            this.params = this.getDefaultParams();
        },
        onPageChange( page ) {
            this.params.Skip = ( page - 1 ) * this.resultsPerPage;
            this.selectedEnquiries = [];
            this.updateRouteFromParams();
        },
        formatMoney( price ) {
            return this.$utils.formatNumber( price, null, 0 );
        },
        getFirstPhoto( property ) {
            let photos = property.Photos;

            if ( !photos || photos.length == 0 ) {
                return null;
            }

            let photo = photos[ 0 ];

            for ( let p of photos ) {
                if ( p.Number < photo.Number ) {
                    photo = p;
                }
            }
            return photo;
        },
        photoUrl( photo ) {
            if ( !photo.CdnUrl ) return photo.Url;

            let url = photo.CdnUrl;
            let urlChunks = url.split( '/' );

            if ( urlChunks.length < 3 ) {
                return '';
            }

            // use https if http is returned
            if ( urlChunks[ 0 ] == 'http:' ) {
                urlChunks[ 0 ] = 'https:';
            }

            urlChunks.splice( urlChunks.length - 1, 0, 's400x300' );

            return urlChunks.join( '/' );
        },
        formatDuration( totalSeconds ) {
            let hours = Math.floor( totalSeconds / 60 / 60 );
            let minutes = Math.floor( totalSeconds / 60 - ( hours * 60 ) );
            let seconds = Math.floor( totalSeconds - ( hours * 60 * 60 ) - ( minutes * 60 ) );
            return `${hours.toString().padStart( 2, '0' )}:${minutes.toString().padStart( 2, '0' )}:${seconds.toString().padStart( 2, '0' )}`;
        },
        async startSearch() {
            this.params.Skip = 0;
            this.updateRouteFromParams();
        },
        async doSearch() {
            this.selectedEnquiries = [];

            this.searchParams = {};
            this.searchParams.Skip = this.params.Skip;
            if ( this.params.Spam != null )
                this.searchParams.Spam = this.params.Spam;
            this.searchParams.Deleted = false;
            this.searchParams.Take = this.resultsPerPage;
            this.searchParams.FromDate = dayjs.tz( this.params.FromDate, 'YYYY-MM-DD', 'Europe/Madrid' ).format();
            this.searchParams.ToDate = dayjs.tz( this.params.ToDate, 'YYYY-MM-DD', 'Europe/Madrid' ).endOf( 'day' ).format();

            if ( this.params.Name.length > 0 ) {
                this.searchParams.Name = `%${this.params.Name}%`;
            }

            if ( this.params.Email.length > 0 ) {
                this.searchParams.Email = `%${this.params.Email}%`;
            }

            if ( this.params.Phone.length > 0 ) {
                this.searchParams.Phone = `%${this.params.Phone}%`;
            }

            if ( this.params.Comment.length > 0 ) {
                this.searchParams.Comment = `%${this.params.Comment}%`;
            }

            if ( this.params.Type.length > 0 && this.params.Type != 'all' ) {
                this.searchParams.Type = this.params.Type;
            }

            if ( this.params.AgentRef.length > 0 ) {
                this.searchParams.AgentRef = `%${this.params.AgentRef}%`;
            }

            if ( this.params.PropertyId > 0 ) {
                this.searchParams.PropertyId = this.params.PropertyId;
            }

            if ( this.params.OfferType > 0 ) {
                this.searchParams.Offer = this.params.OfferType;
            }

            if ( this.params.Logins && this.params.Logins.length > 0 ) {
                this.searchParams.Logins = this.params.Logins;
            }

            if ( this.params.Tickboxes && this.params.Tickboxes.length > 0 ) {
                this.searchParams.Tickboxes = this.params.Tickboxes;
            }

            await this.doSearchFromSearchParams();
        },
        toUrlParams( params ) {
            let urlParams = new URLSearchParams();

            for ( let key in params ) {
                if ( params[ key ] != null ) {
                    if ( Array.isArray( params[ key ] ) ) {
                        for ( let value of params[ key ] ) {
                            urlParams.append( key, value );
                        }
                    } else {
                        urlParams.append( key, params[ key ] );
                    }
                }
            }
            return '?' + urlParams.toString();
        },
        async exportData() {
            this.loading = true;
            this.$store.dispatch( 'appLoading', true );

            let params = JSON.parse( JSON.stringify( this.searchParams ) );

            delete params[ 'Take' ];
            delete params[ 'Skip' ];
            params[ 'Language' ] = 'en';

            let queryString = this.toUrlParams( params );

            let exportQuery = http.get( '/propertycontacts/export' + queryString );

            let exportResult = await exportQuery;

            this.loading = false;
            this.$store.dispatch( 'appLoading', false );

            if ( exportResult.status != 200 ) {
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            const url = window.URL.createObjectURL( await exportResult.blob() );
            const link = document.createElement( 'a' );
            link.href = url;
            link.setAttribute( 'download', 'enquiries.xlsx' ); // or any other extension
            document.body.appendChild( link );
            link.click();
        },
        async doSearchFromSearchParams() {
            this.loading = true;
            this.$store.dispatch( 'appLoading', true );

            let params = this.searchParams;

            let queryString = this.toUrlParams( params );

            let contactsCall = await http.get( '/propertycontacts' + queryString );

            if ( contactsCall.status != 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            let contacts = await contactsCall.json();

            let countParams = JSON.parse( JSON.stringify( params ) );

            delete countParams[ 'Take' ];
            delete countParams[ 'Skip' ];

            queryString = this.toUrlParams( countParams );

            let statsCall = await http.get( '/propertycontacts/stats' + queryString );

            if ( statsCall.status != 200 ) {
                this.$store.dispatch( 'appLoading', true );
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            let stats = await statsCall.json();

            let getIovoxCall = async () => {
                let iovoxCalls  = contacts.filter( c => c.Type == 'iovox-call' );
                if ( iovoxCalls.length == 0 ) {
                    return { ok: true, data: [] };
                }

                let urls = iovoxCalls.map( c => {
                    return `/call/property/${c.Login}/${c.Identifier}`;
                } );

                const callResults = urls.map( url =>
                    http.get( url )
                        .then( response =>
                            response.ok ? response.json() : Promise.reject( `Error loading ${url}` )
                        )
                );

                const results = await Promise.allSettled( callResults );

                const hasErrors = results.some( result => result.status === 'rejected' );

                if ( hasErrors ) {
                    return { ok: false };
                }

                return { ok: true, data: results.map( result => result.value ) };
            };

            let getWebEnquiryCall = async () => {
                let webEnquiry  = contacts.filter( c => c.Type == 'web-enquiry' );
                if ( webEnquiry.length == 0 ) {
                    return { ok: true, data: [] };
                }

                let urls = webEnquiry.map( c => {
                    return `/enquiry/property/${c.Login}/${c.Identifier}`;
                } );

                const callResults = urls.map( url =>
                    http.get( url )
                        .then( response =>
                            response.ok ? response.json() : Promise.reject( `Error loading ${url}` )
                        )
                );

                const results = await Promise.allSettled( callResults );

                const hasErrors = results.some( result => result.status === 'rejected' );

                if ( hasErrors ) {
                    return { ok: false };
                }

                return { ok: true, data: results.map( result => result.value ) };
            };

            let iovoxCalls = await getIovoxCall();
            let webEnquiries = await getWebEnquiryCall();

            if ( !webEnquiries.ok ) {
                notify( {
                    type: 'error',
                    title: 'error occured',
                    text: 'please try again later'
                } );
                return;
            }

            let allEnquieries = [];

            for ( let enq of contacts ) {
                switch ( enq.Type ) {
                case 'web-enquiry': {
                    let data = webEnquiries.data.filter( e => e.Id == enq.Identifier )[ 0 ];
                    allEnquieries.push( { Type: enq.Type, Data: data, Login: enq.Login } );
                    break;
                }
                case 'iovox-call': {
                    let data = iovoxCalls.data.filter( e => e.Id == enq.Identifier )[ 0 ];
                    allEnquieries.push( { Type: enq.Type, Data: data, Login: enq.Login } );
                    break;
                }
                }
            }

            let propertyIds = allEnquieries.filter( e => e.Data && e.Data.PropertyId ).map( e => e.Data.PropertyId );
            if ( propertyIds.length > 0 ) {
                let propertiesCall = await http.get( '/property?' + propertyIds.map( p => `id=${p}` ).join( '&' ) );

                if ( propertiesCall.status != 200 ) {
                    notify( {
                        type: 'error',
                        title: 'error occured',
                        text: 'please try again later'
                    } );
                    return;
                }

                let properties = await propertiesCall.json();
                allEnquieries = allEnquieries.map( e => {
                    if ( e.Data && e.Data.PropertyId ) {
                        e.Property = properties.filter( p => p.Id == e.Data.PropertyId )[ 0 ];
                    }
                    return e;
                } );
            }

            // add property information to all web-enquiry call

            this.pagination.total = stats.count;
            this.pagination.currentPage = Math.ceil( this.searchParams.Skip / this.resultsPerPage ) + 1;
            this.pagination.totalPages = Math.ceil( this.pagination.total / this.searchParams.Take );

            this.enquiries = allEnquieries;

            this.$store.dispatch( 'appLoading', false );
            this.loading = false;
        },
        showPrice( property ) {
            let price = property.PriceInEuro || property.PriceInPounds;
            let currencySign = property.PriceInEuro ? '&euro;' : '&pound;';
            let highPrice = property.HighestPriceInReferedCurrency;

            if ( !property.OfferType || property.OfferType.Id == 3 ) {
                return this.formatNumber( price, null, 0 ) + currencySign;
            }

            if ( property.OfferType.Id == 4 ) {
                return this.formatNumber( price, null, 0 ) + currencySign + ' / month';
            }

            if ( property.OfferType.Id == 2 ) {
                if ( highPrice && highPrice > price ) {
                    return this.formatNumber( price, null, 0 ) + currencySign + ' - ' + this.formatNumber( highPrice, null, 0 ) + currencySign +  ' / week';
                }

                return this.formatNumber( price, null, 0 ) + currencySign + ' / week';
            }

            return '';
        },
        formatNumber( n, c, d, t ) {
            c = isNaN( c = Math.abs( c ) ) ? 2 : c;
            d = d === undefined ? '.' : d;
            t = t === undefined ? ',' : t;

            let s = n < 0 ? '-' : '';
            let i = String( parseInt( n = Math.abs( Number( n ) || 0 ).toFixed( c ) ) );
            let j = 0;

            j = ( j = i.length ) > 3 ? j % 3 : 0;

            return s + ( j ? i.substr( 0, j ) + t : '' ) + i.substr( j ).replace( /(\d{3})(?=\d)/g, '$1' + t ) + ( c ? d + Math.abs( n - i ).toFixed( c ).slice( 2 ) : '' );
        },
        getRowStyle( enquiry ) {
            if ( enquiry.Type == 'iovox-call' ) {
                return '';
            }

            let webEnquiry = enquiry.Data;

            if ( webEnquiry.IsSpam ) {
                return 'background-color:yellow';
            }

            if ( !webEnquiry.IsSent ) {
                return 'background-color:#d24c4c';
            }

            return '';
        },
        formatDate( date ) {
            return dayjs( date ).tz().format( 'DD/MM/YYYY H:mm' );
        },
        getFlag( country ) {
            if ( country === 'en' ) {
                return 'gb';
            }
            return country;
        },
        async resendEmail() {
            this.$store.dispatch( 'appLoading', true );

            let email = this.resendDestination;
            let language = this.resendLanguage;

            let send = async ( enq ) => {
                if ( enq.Type == 'iovox-call' ) {
                    let result = await http.post( `/call/property/${enq.Login}/${enq.Data.Id}/resend`, { email: email, language: language } );
                    return result.status == 200;
                } else {
                    let result = await http.post( `/enquiry/property/${enq.Login}/${enq.Data.Id}/resend`, { email: email, language: language } );
                    return result.status == 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            this.$store.dispatch( 'appLoading', false );

            let withSuccess = results.filter( r => r ).length;
            let withError = results.filter( r => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            let title = 'Emails sent';
            let html = '';
            let type = 'info';
            if ( withError > 0 ) {
                html = `Failed: ${withError}`;
                type = 'error';
            } else if ( withSuccess > 0 ) {
                html = `Send: ${withSuccess}`;
            }

            notify( {
                type: type,
                title: title,
                text: html
            } );

            document.querySelector( '#actions .dropdown-menu' ).classList.remove( 'show' );

            this.doSearch();
        },
        async reportSpam() {
            if ( !window.confirm( `Are you sure you want to mark (${this.selectedEnquiries.length}) as spam with a reason: \n${this.spamReason}` ) ) {
                return;
            }

            this.$store.dispatch( 'appLoading', true );

            let send = async ( enq ) => {
                if ( enq.Type == 'iovox-call' ) {
                    let result = await http.post( `/call/property/${enq.Login}/${enq.Data.Id}/markasspam`, { reason: this.spamReason } );
                    return result.status == 200;
                } else {
                    let result = await http.post( `/enquiry/property/${enq.Login}/${enq.Data.Id}/markasspam`, { reason: this.spamReason } );
                    return result.status == 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            let withSuccess = results.filter( r => r ).length;
            let withError = results.filter( r => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            this.$store.dispatch( 'appLoading', false );

            let title = 'Emails marked as spam';
            let html = '';
            let type = 'info';

            if ( withError > 0 ) {
                html += `Failed: ${withError}`;
                type = 'error';
            } else if ( withSuccess > 0 ) {
                html = `Enquiries marked as spam: ${withSuccess}`;
            }

            notify( {
                type: type,
                title: title,
                text: html
            } );

            document.querySelector( '#actions .dropdown-menu' ).classList.remove( 'show' );
        },
        async removeSpamFlag() {
            if ( !window.confirm( `Are you sure you want to UNMARK (${this.selectedEnquiries.length}) as spam?` ) ) {
                return;
            }

            this.$store.dispatch( 'appLoading', true );

            let send = async ( enq ) => {
                if ( enq.Type == 'web-enquiry' ) {
                    let result = await http.post( `/enquiry/property/${enq.Login}/${enq.Data.Id}/removespamflag` );
                    return result.status == 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            let withSuccess = results.filter( r => r ).length;
            let withError = results.filter( r => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            this.$store.dispatch( 'appLoading', false );

            let title = 'Emails unmarked as spam';
            let html = '';
            let type = 'info';

            if ( withError > 0 ) {
                html += `Failed: ${withError}`;
                type = 'error';
            } else if ( withSuccess > 0 ) {
                html = `Enquiries unmarked as spam: ${withSuccess}`;
            }

            notify( {
                type: type,
                title: title,
                text: html
            } );

            document.querySelector( '#actions .dropdown-menu' ).classList.remove( 'show' );

            this.doSearch();
        },
        async addSpamFlag() {
            if ( !window.confirm( `Are you sure you want to add SPAM flag to (${this.selectedEnquiries.length}) enquiries?` ) ) {
                return;
            }

            this.$store.dispatch( 'appLoading', true );

            let send = async ( enq ) => {
                if ( enq.Type == 'web-enquiry' ) {
                    let result = await http.post( `/enquiry/property/${enq.Login}/${enq.Data.Id}/addspamflag` );
                    return result.status == 200;
                }
            };

            let promises = [];

            for ( let enq of this.selectedEnquiries ) {
                promises.push( send( enq ) );
            }

            let results = await Promise.all( promises );

            let withSuccess = results.filter( r => r ).length;
            let withError = results.filter( r => !r ).length;

            if ( !withError ) {
                this.selectedEnquiries = [];
            }

            this.$store.dispatch( 'appLoading', false );

            let title = 'Spam flag added';
            let html = '';
            let type = 'info';

            if ( withError > 0 ) {
                html += `Failed: ${withError}`;
                type = 'error';
            } else if ( withSuccess > 0 ) {
                html = `Spam flag added: ${withSuccess}`;
            }

            notify( {
                type: type,
                title: title,
                text: html
            } );

            document.querySelector( '#actions .dropdown-menu' ).classList.remove( 'show' );

            this.doSearch();
        }
    },
    components: {
        Pagination
    }
};

</script>



// WEBPACK FOOTER //
// src/components/dashboard/propertyenquiry/form/index.vue